import * as React from 'react';
import {FunctionComponent} from 'react';
import {PartType} from '../../../models/Part';

interface OwnProps {
    onSelect: (partType: PartType) => void;
    onDismiss: () => void;
}

export const SelectType: FunctionComponent<OwnProps> = ({onSelect, onDismiss}) => {
    return (
        <>
            <div className="modal-header">
                <h2>Choose part type</h2>
            </div>
            <div className="modal-body">
                <div className="add-part-wizard">
                    <div className="add-part-wizard__btn-container">
                        <button
                            className="add-part-wizard__select-type-btn"
                            onClick={() => onSelect(PartType.Distance)}
                        >
                            <img src="/images/icons/distance.svg" />
                            <span>Distance</span>
                        </button>

                        <button
                            className="add-part-wizard__select-type-btn"
                            onClick={() => onSelect(PartType.Duration)}
                        >
                            <img src="/images/icons/duration.svg" />
                            <span>Time</span>
                        </button>
                        <button
                            className="add-part-wizard__select-type-btn"
                            onClick={() => onSelect(PartType.Repetitions)}
                        >
                            <img src="/images/icons/repetitions.svg" />
                            <span>Repetitions</span>
                        </button>
                        <button className="add-part-wizard__select-type-btn" onClick={() => onSelect(PartType.Rest)}>
                            <img src="/images/icons/rest.svg" />
                            <span>Rest</span>
                        </button>
                        <button className="add-part-wizard__select-type-btn" onClick={() => onSelect(PartType.OffErg)}>
                            <img src="/images/icons/off_erg.svg" />
                            <span>Off erg</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-secondary pull-right" onClick={onDismiss}>
                    Cancel
                </button>
            </div>
        </>
    );
};
